import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { BeraV2Service } from '@/infra/services/bera-v2';

import type { Response } from '@/types';

export interface FinishBeraJobSummaryParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const FINISH_QUERY_KEYS = ['bera_job_summary', 'bera_job_summary_list', 'bera_report_result'];

const FINISH_ERROR_MESSAGE = 'Failed to finish the B.E.R.A.';

const Service = BeraV2Service.getInstance();

export function useFinishBeraJobSummary() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: FinishBeraJobSummaryParams) => Service.finishJobSummary(params),
		onSuccess: async () => {
			const invalidations = FINISH_QUERY_KEYS.map((key) => queryClient.invalidateQueries([key]));

			await Promise.all(invalidations);
		},
		onError: (err: AxiosError<Response>) => {
			message.error(I18n.get(err.response?.data?.message ?? FINISH_ERROR_MESSAGE));
		}
	});
}
